import type { IconData } from '@stacksjs/iconify-core'

export const commentAltMessage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 9H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m0 4H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\"/><path fill=\"currentColor\" d=\"M19 2H5a3.003 3.003 0 0 0-3 3v10a3.003 3.003 0 0 0 3 3h11.586l3.707 3.707A1 1 0 0 0 22 21V5a3.003 3.003 0 0 0-3-3m-2 11H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m0-4H7a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default commentAltMessage
